import { api, endpoints } from "api/api";
import { BaseApiPaging } from "api/types";
import { AxiosPromise } from "axios";
import { CategoryFormValues } from "pages/Categories/CategoryForm/CategoryForm";

const fetchCategories = (): AxiosPromise<BaseApiPaging<CategoryApi>> => {
  return api.get<BaseApiPaging<CategoryApi>>(endpoints.CATEGORIES.GET());
};

const fetchTree = (): AxiosPromise<CategoryTreeApi[]> => {
  return api.get<CategoryTreeApi[]>(endpoints.CATEGORIES.GET_TREE());
};

const fetchById = (id: number): AxiosPromise<CategoryApi> => {
  return api.get<CategoryApi>(endpoints.CATEGORIES.GET_BY_ID(id));
};

const create = (data: CategoryFormValues): AxiosPromise<number> => {
  return api.post<number>(endpoints.CATEGORIES.CREATE(), data);
};

const update = (id: number, data: CategoryFormValues): AxiosPromise<number> => {
  return api.put<number>(endpoints.CATEGORIES.UPDATE(id), data);
};

export const categoriesApi = {
  fetchCategories,
  fetchTree,
  fetchById,
  create,
  update,
};

export interface CategoryApi {
  name: string;
  id: number;
  friendlyName: string;
  slug: string;
  description: string;
  parentId: number | null;
  sortOrder: number;
  excludeFromSitemap: boolean;
}

export interface CategoryTreeApi extends CategoryApi {
  children: CategoryTreeApi[];
}
